"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CHIP_SEMANTIC", {
  enumerable: true,
  get: function () {
    return _Chip.CHIP_SEMANTIC;
  }
});
Object.defineProperty(exports, "Chip", {
  enumerable: true,
  get: function () {
    return _Chip.Chip;
  }
});
var _Chip = require("./Chip");